import Fetch from "@/utils/Fetch"

export default {
	namespaced: true,
	state() {
		return {
			suppliers: null,
			blackList: null,
			myManager: null,
			supplierStatuses: JSON.parse(localStorage.getItem('supplier-statuses')) || null,
		}
	},
	mutations: {
		setSuppliers(state,suppliers) {
			state.suppliers = suppliers
		},
		setBlackList(state,blackList) {
			state.blackList = blackList
		},
		setMyManager(state,myManager) {
			state.myManager = myManager
		},
		setSupplierStatuses(state,statuses) {
			state.supplierStatuses = statuses
			localStorage.setItem('supplier-statuses', JSON.stringify(statuses))
		}
	},
	actions: {
		async requestSuppliers({commit, dispatch}, filter) {
			commit('startLoading', 'requestSuppliers', {root: true})

			const searchUrl = new URL('/', 'http://nahodka.localhost/')

			Object.entries(filter).forEach(([key, value]) => {

				if(value) {
					searchUrl.searchParams.append(key, String(value))
				}
			})

			const response = await Fetch(`suppliers/${searchUrl.search}`, {
				method: 'GET',
			})

			if (response.success) {
				commit('setSuppliers', response.data)
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestSuppliers', {root: true})

			return {
				...response.data
			}
		},


		async requestBlackList({commit, dispatch}, filter) {
			commit('startLoading', 'requestBlackList', {root: true})

			const searchUrl = new URL('/', 'http://nahodka.localhost/')

			Object.entries(filter).forEach(([key, value]) => {
				if(value) {
					searchUrl.searchParams.append(key, String(value))
				}
			})

			const response = await Fetch(`suppliers/blacklist/${searchUrl.search}`, {
				method: 'GET',
			})

			if (response.success) {
				commit('setBlackList', response.data)
			} else {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestBlackList', {root: true})

			return {
				...response.data
			}
		},

		async requestSupplier({commit, dispatch}, id) {
			commit('startLoading', 'requestSupplier', {root: true})

			const response = await Fetch(`suppliers/get/${id}/`, {
				method: 'GET',
			})

			if (!response.success) {
				dispatch('showError', response.message, {root: true})
			}

			commit('stopLoading', 'requestSupplier', {root: true})

			return {
				...response
			}
		},

		async requestMyManager({commit, dispatch}) {
			commit('startLoading', 'requestMyManager', {root: true})

			const response = await Fetch('suppliers/my-managers/', {
				method: 'GET',
			});
			if (response.success) {
				commit('setMyManager', response.data)
			} else {
				dispatch('showError', response.message, {root: true})
			}
			commit('stopLoading', 'requestMyManager', {root: true})
			return {
				...response
			}
		},
		async requestSupplierStatuses({commit, dispatch, state}) {
			if(state.supplierStatuses) return state.supplierStatuses
			const response = await Fetch('info/supplier-statuses/', {
				method: 'GET',
			});
			if (response.success) {
				commit('setSupplierStatuses', response.data)
			} else {
				dispatch('showError', response.message, {root: true})
			}
			return {
				...response
			}
		}
	},

	getters: {
		getSuppliers: state => state.suppliers,
		getBlackList: state => state.blackList,
		getMyManager: state => state.myManager,
		getSupplierStatuses: state => state.supplierStatuses
	}
}

